import React from 'react';

const Footer = React.memo((props) => {
    const handleClick = (event) => {
        event.preventDefault();
        props.showTermOfUseModal();
    };

    return (
        <div className="footer-container">
            <div className="powered">
                Powered by Corporate Storefront
                <br />
                Online Storefront Development Company
                <br />
                <a href="/" onClick={handleClick}>Term of Use</a>
            </div>
        </div>
    );
});

export default Footer;
